import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Button, ButtonDropdown, DropdownItem, Icon, WeezHeader } from '@weezevent/nacre';

export default function statusesTransitions({ organization, flowId, children }) {
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <>
            <WeezHeader
                title={t('ticket.moderation.statusesTransitions.title')}
                rightComponent={[
                    <ButtonDropdown
                        key={0}
                        renderWhenClosed
                        trigger={<Button primary icon={<Icon name="plus" />} label={t('ticket.common.action.add')} />}
                        items={
                            <>
                                <DropdownItem
                                    item={t('ticket.moderation.statusesTransitions.addStatus')}
                                    onClick={() => history.push(`/ticket/O${organization.id}/moderation/moderation_flows/${flowId}/statuses_transitions/statuses/new`)}
                                />
                                <DropdownItem
                                    item={t('ticket.moderation.statusesTransitions.addTransition')}
                                    onClick={() => history.push(`/ticket/O${organization.id}/moderation/moderation_flows/${flowId}/statuses_transitions/transitions/new`)}
                                />
                            </>
                        }
                    />
                ]}
            >
                {t('ticket.moderation.statusesTransitions.subtitle')}
            </WeezHeader>
            {React.cloneElement(children, { organization, flowId })}
        </>
    );
}
